// extracted by mini-css-extract-plugin
module.exports = {"languageInput":"LanguageSwitcher_languageInput__lb3em","languageSelectorContainer":"LanguageSwitcher_languageSelectorContainer__WCi0c","langBtn":"LanguageSwitcher_langBtn__bJyEy"};